// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__B-xG7","image":"NavBar_image__1YEXl"};